// AUTO-GENERATED by scripts/convert-rn-icons.ts from libs/component-library/src/lib/icons/icons.tsx - do not edit.
import { FxSvg, type FxSvgProps } from '../FxSvg.js';

export const FxCloseIcon = (props: FxSvgProps) => (
  <FxSvg width="18" height="18" viewBox="0 0 18 18" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.4697 17.5303C16.7626 17.8232 17.2374 17.8232 17.5303 17.5303C17.8232 17.2374 17.8232 16.7626 17.5303 16.4697L10.0607 9L17.5303 1.53033C17.8232 1.23744 17.8232 0.762564 17.5303 0.469669C17.2374 0.176777 16.7626 0.176777 16.4697 0.469669L9 7.93934L1.53033 0.469669C1.23744 0.176777 0.762564 0.176777 0.469669 0.469669C0.176777 0.762564 0.176777 1.23744 0.469669 1.53033L7.93934 9L0.46967 16.4697C0.176777 16.7626 0.176777 17.2374 0.46967 17.5303C0.762563 17.8232 1.23744 17.8232 1.53033 17.5303L9 10.0607L16.4697 17.5303Z"
    />
  </FxSvg>
);
